//@ts-check

// External
import React, { useEffect, Suspense, useRef, useState } from "react"
//@ts-ignore
import {
  Route,
  Switch,
  BrowserRouter,
  Redirect,
  useHistory,
} from "react-router-dom"
//@ts-ignore
// Internal
import AppBar from "../components/app-bar"
import SnackBars from "../components/snack-bars"
import useIsLoggedIn from "../utils/use-is-logged-in"
// @ts-ignore
import Home from "./home"
import Loader from "../components/block-loader"
import "../utils/translate"
import store from "../store"
import Simulations from "./simulations"
import OneSimulation from "./one-simulation"
import consts from "shared/consts"
import SideMenu from "../components/side-menu"
import CustomToaster from "src/components/custom-toaster"
import SolidityWizard from "./solidity-wizard"
import Simplifier from "./simplifier"
import MyReviews from "./my-reviews"
import EngagementManager from "./engagement-manager"
import ErrorBoundary from "../components/ErrorBoundary"
import {
  useHideOnPrintStyleSheet,
  useStyleSheet,
} from "../utils/use-style-sheet"
import ErcBalanceCheck from "./ercBalanceChecker"
import CiReviews from "./ci-reviews"
import Analytics from "src/components/analytics"
import Wc from "./wc"
import AppContainer from "./app-container"
import AuthError from "../components/autherror"
import CompileDialogForReview from "../components/compileDialogForReview"
import OrganizationManager from "./organization-manager"
import scAnalyzer from "../SCAnalyzer/SCAnalyzer"
import SCAnalyzer from "../SCAnalyzer/SCAnalyzer"
import AskQuestion from "./ask-question"
import AI from "./ai"
import GetContractABI from "./get-contract-abi"
import VerifyContractByteCode from "./verify-contract-byte-code"
import AIReviewAgent from "./ai-review-agent"
import V2Routes from "src/v2/v2-routes"
// Fix object pollution
Object.freeze(Object.prototype)

function App() {
  useStyleSheet(`button {
      background-color:white;
      border:1px solid #ccc;
      padding:5px 10px;
  }
  `)

  useHideOnPrintStyleSheet()
  // State and Hooks (state managed by hooks)
  const { isLoggedIn, userInfo } = useIsLoggedIn()

  const [isLoading, setIsSubmitLoading] = useState(false)

  store.useRerenderIfChange(() => [
    store.solidityCompilerVersions?.length,
    store.showEditReviewFileModal_reviewId,
  ])
  // Refs
  const scanningCancelled = useRef(false)

  const requestCancelScan = () => {
    scanningCancelled.current = true
    setIsSubmitLoading(false)
  }

  useEffect(() => {
    if (isLoggedIn && window["config"].SHOW_EXPIRED_MESSAGE === "true") {
      var interval = setInterval(() => {
        const activeToken = atob(
          document.cookie.match(/token=([a-z\d]+).([a-z\d]+).([a-z\d]+)/i)[2],
        )
        const expiryDate = JSON.parse(activeToken).exp * 1000
        if (new Date(expiryDate) < new Date()) {
          store.showToaster(
            "info",
            "Your access token has expired. Please login",
          )
        }
      }, 3000)
    }
    return () => clearInterval(interval)
  }, [isLoggedIn])

  if (
    !store.loadingSolidityCompilerVersions &&
    !store.solidityCompilerVersions?.length
  ) {
    // If not currently loading, and not finish loadeding:
    store.loadSolidityCompilerVersions() // it will update the store.solidityComplierVersions array.
  }
  var [refreshing, set_refreshing] = useState(false)
  function refresh() {
    set_refreshing(true)
    setTimeout(() => {
      set_refreshing(false)
      store.history.push("/")
    }, 100)
  }

  if (refreshing) {
    return false
  }

  // If array not ready yet. do not load the page yet.
  if (!store.solidityCompilerVersions?.length) {
    return null
  }

  return (
    <BrowserRouter>
      <AppBar>
        <AppContainer>
          {store.showEditReviewFileModal_reviewId && (
            <CompileDialogForReview
              reviewId={store.showEditReviewFileModal_reviewId}
              requestClose={() => {
                store.showEditReviewFileModal_completer.complete()
              }}
            />
          )}
          <div>
            <CustomToaster />
            <AddHistoryToStore />
            {isLoading && <Loader onClick={requestCancelScan} />}
            <div>
              <AuthError />
              {/* <ErrorBoundary
                onError={(errorInfo) => {
                  return (
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <b>An error occurred. Please refresh the page.</b>
                      <br />
                      <button
                        onClick={refresh}
                        style={{
                          backgroundColor: "#007BFF",
                          color: "white",
                          border: "none",
                          padding: "10px 20px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          marginTop: "10px",
                        }}
                      >
                        Refresh
                      </button>
                    </div>
                  )
                }}
              > */}
                <Route path="/v2">
                  <V2Routes />
                </Route>
                <Switch>
                  <Route path="/subscriptions/:param">
                      <RedirectToLogin />
                  </Route>
                  <Route path="/solidity-wizard/:id">
                    <SideMenu>
                      <SolidityWizard />
                    </SideMenu>
                  </Route>
                  <Route path="/simplifier/:id">
                    <SideMenu>
                      <Simplifier
                        setIsSubmitLoading={setIsSubmitLoading}
                        isLoading={isLoading}
                        scanningCancelled={scanningCancelled}
                      />
                    </SideMenu>
                  </Route>
                  <Route path={consts.SCR_APP_URLS.myReview}>
                    <SideMenu>
                      <MyReviews />
                    </SideMenu>
                  </Route>
                  <Route path={consts.SCR_APP_URLS.ciReview + "/:id"}>
                    <SideMenu>
                      <CiReviews />
                    </SideMenu>
                  </Route>
                  <Route path={consts.SCR_APP_URLS.engagementManager}>
                    <SideMenu>
                      <EngagementManager />
                    </SideMenu>
                  </Route>
                  {!userInfo?.auth0Subscripton && (
                    <Route path={consts.SCR_APP_URLS.organizationManager}>
                      <SideMenu>
                        <OrganizationManager />
                      </SideMenu>
                    </Route>
                  )}
                  <Route path="/library/simulation/:id">
                    <SideMenu>
                      <OneSimulation />
                    </SideMenu>
                  </Route>
                  <Route path={consts.SCR_APP_URLS.library}>
                    <SideMenu>
                      <Simulations />
                    </SideMenu>
                  </Route>
                  <Route path={consts.SCR_APP_URLS.ercBalanceCheck}>
                    <SideMenu>
                      <ErcBalanceCheck />
                    </SideMenu>
                  </Route>
                  <Route path="/library/simulation/:id">
                    <SideMenu>
                      <OneSimulation />
                    </SideMenu>
                  </Route>
                  <Route path={consts.SCR_APP_URLS.library}>
                    <SideMenu>
                      <Simulations />
                    </SideMenu>
                  </Route>
                  <Route path={consts.SCR_APP_URLS.analytics}>
                    <SideMenu>
                      <Analytics />
                    </SideMenu>
                  </Route>
                  <Route exact path={consts.SCR_APP_URLS.ai}>
                    <SideMenu>
                      <AI />
                    </SideMenu>
                  </Route>
                  <Route exact path={consts.SCR_APP_URLS.automated}>
                    <SideMenu>
                      <Home
                        scanningCancelled={scanningCancelled}
                        isLoading={isLoading}
                        setIsSubmitLoading={setIsSubmitLoading}
                      />
                    </SideMenu>
                    <SnackBars />
                  </Route>
                  <Route exact path="/wc">
                    <SideMenu>
                      <Wc />
                    </SideMenu>
                  </Route>
                  <Route exact path="/">
                    <SideMenu>
                      <Redirect to={consts.SCR_APP_URLS.library} />
                    </SideMenu>
                  </Route>
                  {window["config"].SHOW_ANALYZER === "YES" && (
                    <Route path={consts.SCR_APP_URLS.scAnalyzer}>
                      <SideMenu>
                        <SCAnalyzer />
                      </SideMenu>
                    </Route>
                  )}
                  <Route path={consts.SCR_APP_URLS.askQuestion}>
                    <SideMenu>
                      <AskQuestion />
                    </SideMenu>
                  </Route>
                  <Route path={consts.SCR_APP_URLS.getContractABI}>
                    <SideMenu>
                      <GetContractABI />
                    </SideMenu>
                  </Route>
                    <Route path={consts.SCR_APP_URLS.aiReviewAgent}>
                    <SideMenu>
                      <AIReviewAgent/>
                      </SideMenu>
                    </Route>
                    <Route path={consts.SCR_APP_URLS.verifyContractByteCode}>
                    <SideMenu>
                      <VerifyContractByteCode />
                    </SideMenu>
                  </Route>
                </Switch>
              {/* </ErrorBoundary> */}
              <SnackBars />
            </div>
          </div>
        </AppContainer>
      </AppBar>
    </BrowserRouter>
  )
}
function AddHistoryToStore() {
  store.history = useHistory()
  return null
}
function RedirectToLogin() {
  var subscriptionId = location.href.split("/").pop()
  useEffect(() => {
    window.open(
      window["config"].AUTH_UI + "?subscriptionId=" + subscriptionId,
      "_top",
    )
  }, [])
  return null
}
export default App
